<template>
  <div>
    <v-alert v-if="somenteMensalidades" type="info" outlined dense class="mt-4">
      A parcela de matrícula já existe, paga na pré-matrícula. Serão geradas apenas as mensalidades
      restantes.
    </v-alert>
    <v-row>
      <v-col v-if="!somenteMensalidades" class="pt-0 pb-0 mt-4" cols="6">
        <e-label>Valor da Matrícula</e-label>
        <v-currency-field
          @input="changeParcelas"
          v-model="valor_matricula"
          locale="pt-BR"
          :rules="[valorMaiorQueZero]"
          prefix="R$"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-4" cols="6">
        <e-label>Valor da Mensalidade</e-label>
        <v-currency-field
          @input="changeParcelas"
          v-model="valor_mensalidade"
          locale="pt-BR"
          :rules="[valorMaiorQueZero]"
          prefix="R$"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-4" cols="6">
        <e-label>Mês de Início</e-label>
        <v-select
          @change="changeParcelas"
          :items="$constants.meses"
          item-text="descricao"
          item-value="id"
          v-model="mesInicio"
          return-object
          label="Selecione um mês"
          :rules="[campoObrigatorio]"
          required
          solo
        ></v-select>
      </v-col>
      <v-col class="pt-0 pb-0 mt-4" cols="6">
        <e-label>Mês Final</e-label>
        <v-select
          @change="changeParcelas"
          :items="$constants.meses"
          item-text="descricao"
          item-value="id"
          v-model="mesFinal"
          return-object
          label="Selecione um mês"
          :rules="[campoObrigatorio]"
          required
          solo
        ></v-select>
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="4">
        <e-label>Dia de Vencimento</e-label>
        <v-text-field
          @input="changeParcelas"
          v-model="vencimento"
          type="number"
          :max="31"
          :min="1"
          :rules="[diaObrigatorio]"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="4">
        <e-label>Desconto 1</e-label>
        <v-currency-field
          @input="changeParcelas"
          v-model="desconto_1"
          locale="pt-BR"
          :rules="[campoObrigatorio]"
          prefix="R$"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="2">
        <e-label>Dia Desc. 1</e-label>
        <v-text-field
          v-model="descontoDia"
          @input="changeParcelas"
          type="number"
          :max="31"
          :min="1"
          :rules="[diaObrigatorio]"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="3">
        <e-label>Desconto 2</e-label>
        <v-currency-field
          @input="changeParcelas"
          v-model="desconto_2"
          locale="pt-BR"
          :rules="[campoObrigatorio]"
          prefix="R$"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="2">
        <e-label>Dia Desc. 2</e-label>
        <v-text-field
          v-model="descontoDia2"
          @input="changeParcelas"
          type="number"
          :max="31"
          :min="1"
          :rules="[diaObrigatorio]"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="3">
        <e-label>Desconto 3</e-label>
        <v-currency-field
          @input="changeParcelas"
          v-model="desconto_3"
          locale="pt-BR"
          :rules="[campoObrigatorio]"
          prefix="R$"
          required
          solo
        />
      </v-col>
      <v-col class="pt-0 pb-0 mt-0" cols="2">
        <e-label>Dia Desc. 3</e-label>
        <v-text-field
          v-model="descontoDia3"
          @input="changeParcelas"
          type="number"
          :max="31"
          :min="1"
          :rules="[diaObrigatorio]"
          required
          solo
        />
      </v-col>
    </v-row>

    <v-data-table :headers="cabecalhos" :items="parcelas" :items-per-page="26">
      <template v-slot:item.referencia="{ item: parcela }">
        {{ parcela.referencia_3 | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
      </template>
      <template v-slot:item.valor="{ item: parcela }">
        {{ parcela.valor | currency }}
      </template>
    </v-data-table>

    <v-btn
      color="primary"
      :disabled="parcelas.length < 1"
      class="ms-3 mb-3"
      @click="vincularParcelas()"
    >
      Gerar Parcelas
    </v-btn>
  </div>
</template>

<script>
import gerarMensalidadesMixin from "./gerarMensalidadesMixin";

/** Geração das parcelas no layout da tela de Mensalidades. */
export default {
  name: "EGerarMensalidades",
  mixins: [gerarMensalidadesMixin],
};
</script>
